import React, { useState } from 'react';
import { ArrowRight, X } from 'lucide-react';
import { galleryImages } from '../../mock/data';
import { Cloud, Leaf, Star } from './Decor';
import { useQuery } from '@tanstack/react-query';
import api, { assetUrl } from '../../services/api';

const Gallery = () => {
  const [active, setActive] = useState(null);
  const { data } = useQuery({ queryKey: ['public-galleries'], queryFn: () => api.get('/galleries').then((r) => r.data), retry: false });
  const remote = data?.data || [];
  const images = remote.length ? remote.map((g) => ({
    src: assetUrl(g.cover_image) || galleryImages[0].src, title: g.title, tags: `${g.items_count || 0} foto`,
    place: g.event_date || 'Galeri Sekolah', slug: g.slug,
  })) : galleryImages;

  return (
    <section id="galeri" className="relative overflow-hidden pt-24 pb-32" style={{ background: '#fff6e2' }}>
      <div className="absolute inset-0 pointer-events-none">
        <Cloud size={220} className="absolute top-8 left-[-30px] opacity-70" tone="#fff" />
        <Cloud size={260} className="absolute top-16 right-[-40px] opacity-70" tone="#fff" />
        <Leaf size={54} className="absolute top-[30%] left-[3%] animate-float" />
        <Leaf size={70} className="absolute bottom-24 right-[4%] animate-float" color="#a8d97e" />
        <Star size={28} className="absolute top-24 right-[18%] animate-twinkle" />
      </div>

      <div className="relative max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="font-hand text-[15px] tracking-[0.35em] text-[#c74a2a] mb-2">GALERI KEGIATAN</div>
            <h2 className="font-brush text-[46px] md:text-[64px] leading-[1] text-[#2b8b98]">
              Momen Ceria Anak-anak
            </h2>
            <p className="mt-4 max-w-[560px] font-hand text-[18px] text-[#4a3b2a]/85">
              Setiap hari adalah petualangan baru. Berikut adalah beberapa momen kesukaan kami.
            </p>
          </div>
          <button className="self-start md:self-auto inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#2a2a2a] text-white font-hand text-[15px] hover:bg-[#3a3a3a] transition-colors">
            Semua Galeri <ArrowRight size={16} />
          </button>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
          {images.map((g, idx) => (
            <button
              key={idx}
              onClick={() => setActive(g)}
              className={`group relative overflow-hidden rounded-[24px] border-4 border-white shadow-[0_10px_0_rgba(200,170,120,0.35)] text-left ${
                idx % 5 === 0 ? 'md:col-span-2 md:row-span-1' : ''
              }`}
              style={{ aspectRatio: idx % 5 === 0 ? '2 / 1' : '4 / 3' }}
            >
              <img
                src={g.src}
                alt={g.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#3a2a1a]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-3 left-4 right-4 text-white translate-y-6 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <div className="font-brush text-[26px] leading-none">{g.title}</div>
                <div className="font-hand text-[13px] opacity-85">{g.place} • {g.tags}</div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-6 animate-fade-up"
          onClick={() => setActive(null)}
        >
          <div
            className="relative max-w-[900px] w-full bg-white rounded-[24px] overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setActive(null)}
              className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center hover:bg-white z-10"
              aria-label="Tutup"
            >
              <X size={20} />
            </button>
            <img src={active.src} alt={active.title} className="w-full max-h-[70vh] object-cover" />
            <div className="p-6">
              <h3 className="font-brush text-[32px] text-[#2b8b98]">{active.title}</h3>
              <p className="font-hand text-[15px] text-[#4a3b2a]/80">{active.place} • {active.tags}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
